import React from "react";
import type { SocialLink } from "../Footer.types";

interface SocialLinksProps {
    links: SocialLink[];
    className?: string;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ links, className = "" }) => {
    if (!links || links.length === 0) return null;

    return (
        <ul className={`flex items-center ${className}`}>
            {links.map(({ href, label, icon, hoverColor }, i) => (
                <li key={label} className={i !== 0 ? "ml-6" : ""}>
                    <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={label}
                        className={`text-white transition-colors duration-200 ${hoverColor || "hover:text-gray-300"}`}
                    >
                        <i className={`bi ${icon}`} />
                        <span className="sr-only">{label} (opens in a new window)</span>
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default SocialLinks;